export const PERCENT_INFORMED_BY_CLIENT_TO_SHOW_PROGRESS_BAR = 35;
